<template>
  <div class="row py-5 px-10">
    <MessageComponent :form="formData" @load="loadData" v-model:submitted="hasSubmitted" />
  </div>
</template>

<script setup>
import {computed, onMounted, ref, onBeforeUnmount} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import MessageComponent from "./components/Modals/MessageComponent.vue";
import {$formatToYmdHi, extractValidEmails, formatArray} from "@/mixins/Helpers";

const router = useRouter()
const route = useRoute()
const store = useStore()

const title = ref("mail.new_message")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.mail.list',
    route: 'mail-index'
  },
  {
    name: 'mail.new_message',
    route: 'mail-create'
  }
])

const formData = ref({
  to: [],
  cc: [],
  bcc: [],
  subject: '',
  message: '',
  attachments: [],
  scheduled_at: '',
  priority: '3 (Normal)',
  request_receipt: false,
  is_draft: false
})
const hasSubmitted = ref(false)

const folder = computed(() => decodeURIComponent(decodeURIComponent(route.query.tab)))

function loadData() {
  router.push({name: 'mail-index'})
}


function prepareDraftData() {
  return {
    ...formData.value,
    is_draft: true,
    folder: route.query.tab,
    scheduled_at: $formatToYmdHi(formData.value.scheduled_at),
    to: extractValidEmails(formData.value.to),
    cc: extractValidEmails(formData.value.cc),
    bcc: extractValidEmails(formData.value.bcc),
  };
}


onMounted(() => {
  const handleBeforeUnload = () => {
    if (!hasSubmitted.value) {
      if (window.opener && typeof window.opener.onChildWindowClose === "function") {
        const data = prepareDraftData();
        window.opener.onChildWindowClose(data);
      }
    }
  };

  window.addEventListener("beforeunload", handleBeforeUnload);

  onBeforeUnmount(() => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  });
});

</script>

<style scoped>
.dropdown-toggle::after {
  display: none !important;
}

.custom-checkbox {
  appearance: none;
  width: 15px;
  height: 15px;
  background-color: var(--bs-light-primary);
  border-radius: 4px;
  cursor: pointer;
  position: relative;
}

.custom-checkbox:checked {
  background-color: var(--bs-primary);
}

.custom-checkbox:checked::after {
  content: '✔';
  color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
}

.custom-radio {
  appearance: none;
  width: 13px;
  height: 13px;
  background-color: var(--bs-light-primary);
  border-radius: 50%;
  cursor: pointer;
  position: relative;
}

.text-light-primary {
  color: var(--bs-light-primary) !important;
}

.custom-radio:checked {
  background-color: var(--bs-primary);
}

.custom-radio:checked::after {
  content: '';
  color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
}

.active_tr {
  margin: 10px 50px !important;
  font-weight: 600 !important;
}

.selected_tr {
  background-color: var(--bs-light-primary);
  margin: 10px 50px !important;
}

.spinner-overlay {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  border: 6px solid #f3f3f3;
  border-top: 5px solid var(--bs-primary);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
  margin-left: 48%;
  margin-top: 5%;
  margin-bottom: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.active_tab {
  background-color: var(--bs-light-primary);
  border-radius: 5px;
}

.button {
  position: relative;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
  padding-block: 0.5rem;
  padding-inline: 1.25rem;
  background-color: var(--bs-primary);
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffff;
  gap: 10px;
  font-weight: bold;
  border: 3px solid #ffffff4d;
  outline: none;
  overflow: hidden;
  font-size: 15px;
}

.icon {
  width: 24px;
  height: 24px;
  transition: all 0.3s ease-in-out;
}

.button:hover {
  transform: scale(1.05);
  border-color: #fff9;
}

.button:hover .icon {
  transform: translate(4px);
}

.button:hover::before {
  animation: shine 1.5s ease-out infinite;
}

.button::before {
  content: "";
  position: absolute;
  width: 100px;
  height: 100%;
  background-image: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0.8),
      rgba(255, 255, 255, 0) 70%
  );
  top: 0;
  left: -100px;
  opacity: 0.6;
}

@keyframes shine {
  0% {
    left: -100px;
  }

  60% {
    left: 100%;
  }

  to {
    left: 100%;
  }
}

.folder:hover {
  background-color: var(--bs-light-primary) !important;
  border-radius: 5px;
}
</style>
